import {createItem, updateItem, deleteItem} from './actionUtils'
import { url } from '../../constants/urls';

/***  Folder Actions ***/
export const setAccountConfigurations= (accountSettings) => {
    return updateItem('SET_ACCOUNT_CONFIGURATION',  url.baseURL+'/accountconfiguration/update', accountSettings, 'Settings updated', 'Failed to update settings.', true)
}
